import React from 'react';
import PropTypes from 'prop-types';
import {Icon, Button} from 'components';
import styles from './FileUploaderButton.scss';

const FileStackButton = ({
    onUploadFile,
    text,
    ...otherProps
}) =>
    <Button
        className={styles.uploadFile}
        onClick={onUploadFile}
        aria-label={text}
        disableRipple
        {...otherProps}
    >
        <Icon name='ion-md-cloud-upload' /> { text }
    </Button>;

FileStackButton.propTypes = {
    onUploadFile: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
};

export default FileStackButton;
